<template>
  <v-dialog v-model="isOpen" persistent max-width="450px">
    <div class="position-relative">
      <v-card>
        <v-card-title class="justify-content-center">
          <p class="text-center" style="width: 440px"> "{{title}}" </p>
          <p class="text-center mb-0">{{ translations('shipping_instruction.delete_remarks') }}</p>
        </v-card-title>
        <v-card-actions class="pb-6 px-6 justify-content-center">
          <button
            type="button"
            class="btn btn-secondary mr-3"
            @click="close"
            style="width: 100px"
            >
            {{ translations('shipping_instruction.cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="deleteDocument" style="width: 100px">OK</button>
        </v-card-actions>
      </v-card>
      <loading-component :is-loading="isLoading"/>
    </div>
  </v-dialog>
</template>

<script>
import LoadingComponent from './loading/LoadingComponent.vue'
import _isEmpty from 'lodash/isEmpty'
import { mapState } from 'vuex'

export default {
  name: 'DocumentFormModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LoadingComponent
  },
  watch: {
    document: {
      handler: function (val) {
        if (!_isEmpty(val)) {
          this.title = val.title
          this.documentId = Number(val.id)
        }
      },
      deep: true
    }
  },
  data () {
    return {
      isLoading: false,
      title: '',
      documentId: 0
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    init () {
      this.title = ''
      this.documentId = ''
    },
    async deleteDocument () {
      this.isLoading = true
      try {
        const { data: { status, message } } = await this.$http.post(this.$api_url.delete_template_shipping_instruction + this.documentId)
        if (status) {
          this.$toastr.success(this.translations('shipping_instruction.notice_update_completed'), this.translations('common.success'))
          this.init()
          this.$emit('close', false, true)
        } else {
          this.$toastr.error(message, this.translations('common.error'))
        }
      } catch (error) {}
      this.isLoading = false
    },
    close () {
      this.init()
      this.$emit('close', false)
    }
  }
}
</script>

<style scoped>

.position-relative {
  position: relative;
}
</style>
